import React from 'react';
import { Input, RadioGroup, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';
import { BLOG_TYPE_OPTIONS, CITING_RADIO_OPTIONS } from '../../forms/blog/constants';
import { useFormikContext } from 'formik';
/** blog citing section id and testId */
export var SECTION_ID = 'blog-citing-section';
export var SECTION_TEST_ID = 'blog-citing-section-test-id';
export var CITING_RADIO_INPUT_TITLE = 'Citing';
export var BLOG_TYPE_RADIO_INPUT_TITLE = 'Blog type';
export var CITING_RADIO_INPUT_TEST_ID = 'citing-radio-input-test-id';
export var BLOG_TYPE_RADIO_INPUT_TEST_ID = 'blog_type-radio-input-test-id';
export var BLOG_ARTICLE_TITLE_INPUT_TEST_ID = 'blog-article-title-input-test-id';
export var BlogCitingSection = function BlogCitingSection() {
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var handleContributors = function handleContributors() {
    setFieldValue('contributors', []);
  };
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    options: CITING_RADIO_OPTIONS,
    legend: CITING_RADIO_INPUT_TITLE,
    name: "posttype",
    formikFieldName: 'blog.posttype',
    align: "horizontal",
    "data-test": CITING_RADIO_INPUT_TEST_ID,
    onChange: handleContributors,
    defaultSelectedIndex: -1
  }), /*#__PURE__*/React.createElement(RadioGroup, {
    options: BLOG_TYPE_OPTIONS,
    legend: BLOG_TYPE_RADIO_INPUT_TITLE,
    name: "type",
    formikFieldName: 'blog.type',
    align: "horizontal",
    "data-test": BLOG_TYPE_RADIO_INPUT_TEST_ID,
    defaultSelectedIndex: -1
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "blog.title",
    labelText: "Article title",
    "data-test": BLOG_ARTICLE_TITLE_INPUT_TEST_ID
  }));
};